// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendar {
  background: #f3f4f6 !important;
  overflow: hidden !important;
  height: 170vh;
}
.calendar__head {
  display: flex;
  align-items: center;
  padding: 60px 42px 0px 42px;
}
.calendar__head__text {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  color: #333333;
}
.calendar__head__button {
  margin-left: auto;
}
.calendar__events {
  display: flex;
}
.calendar__events__icon {
  margin-right: 10px;
  margin-left: 5px;
}
.calendar__main {
  padding: 20px 42px 50px 42px;
}

.fc-view-harness {
  height: 133vh !important;
}

.fc-daygrid {
  border-radius: 16px;
}

.fc-daygrid-day-top {
  float: left;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #868686;
}

.fc-scrollgrid-sync-inner {
  float: left;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
  margin-top: 5px;
}

.fc-scrollgrid-sync-table {
  background: white;
}

.fc-day-today {
  background: #fffcf2 !important;
}

.fc-theme-standard td,
.fc-theme-standard th {
  border: 1px solid #f2f2f2;
}

.fc-scroller-harness {
  border-bottom: 1px solid #e9e9e9;
}

.fc-scroller {
  overflow: hidden !important;
}

.fc-col-header-cell {
  background: white !important;
  height: 50px;
}

.fc-daygrid-day-events {
  padding-top: 30px;
}

.fc-daygrid-day {
  height: 170px;
}

.fc-toolbar-chunk {
  display: flex;
  padding-left: 0px;
}

.fc-toolbar-title {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500 !important;
  font-size: 18px !important;
  color: #505054 !important;
  padding-top: 8px;
  margin-left: 0px !important;
}

.fc-prev-button {
  background: none !important;
  border: none !important;
  padding-left: 0px !important;
}

.fc-icon-chevron-left {
  color: #505054 !important;
}

.fc-next-button {
  background: none !important;
  border: none !important;
  margin-left: 0px !important;
}

.fc-icon-chevron-right {
  color: #505054 !important;
}

.fc-h-event {
  background: none !important;
  border: none !important;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  display: flex;
  color: #333333 !important;
}

.fc-scrollgrid {
  border: none !important;
}

.fc .fc-scrollgrid-liquid {
  background: white;
  padding: 10px;
  border-radius: 16px;
  height: none;
  height: 125vh;
}

.fc-daygrid-day-number {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #868686;
}

.fc-col-header-cell-cushion {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}

.fc-event-main {
  color: #333333 !important;
}

.x {
  z-index: 100;
  color: black;
}

.position-relative {
  position: relative;
  padding: 100px;
}

.swal2-popup {
  position: relative !important;
  left: var(--x) px !important;
  left: 300px;
  top: 200px;
}

.someClass {
  background: var(--bg);
  position: relative;
  left: var(--x) !important;
  top: var(--y) !important;
  height: 150px;
  width: 400px;
}

.calendar-modal {
  position: fixed;
  left: var(--xDir) !important;
  top: var(--yDir) !important;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}
.calendar-modal__popup {
  position: block;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  left: var(--x) !important;
  top: var(--y) !important;
  height: 165px;
  width: 472px;
  padding: 30px;
}
.calendar-modal__action {
  display: flex;
}
.calendar-modal__close {
  margin-left: auto;
  cursor: pointer;
}
.calendar-modal__icons {
  margin-right: 20px;
  cursor: pointer;
}
.calendar-modal__task-name {
  margin-top: 20px;
  display: flex;
}
.calendar-modal__task-name__icon {
  align-content: center;
  margin-right: 10px;
}
.calendar-modal__task-name__text {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #333333;
}
.calendar-modal__dates {
  margin-top: 10px;
}
.calendar-modal__dates__task-date-range {
  display: flex;
}
.calendar-modal__dates__task-date-range__text {
  margin-right: 5px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #868686;
}
.calendar-modal__dates__task-date-range__dates {
  margin-right: 5px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
}`, "",{"version":3,"sources":["webpack://./src/components/calendar/calendar.scss"],"names":[],"mappings":"AAAA;EACI,8BAAA;EACA,2BAAA;EACA,aAAA;AACJ;AACI;EACI,aAAA;EACA,mBAAA;EACA,2BAAA;AACR;AACQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AACZ;AAEQ;EACI,iBAAA;AAAZ;AAII;EACI,aAAA;AAFR;AAIQ;EACI,kBAAA;EACA,gBAAA;AAFZ;AAMI;EACI,4BAAA;AAJR;;AAQA;EACI,wBAAA;AALJ;;AAQA;EACI,mBAAA;AALJ;;AAQA;EACI,WAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AALJ;;AAQA;EACI,WAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EAEA,eAAA;AANJ;;AASA;EACI,iBAAA;AANJ;;AASA;EACI,8BAAA;AANJ;;AASA;;EAEI,yBAAA;AANJ;;AASA;EACI,gCAAA;AANJ;;AASA;EACI,2BAAA;AANJ;;AASA;EACI,4BAAA;EACA,YAAA;AANJ;;AAUA;EACI,iBAAA;AAPJ;;AAUA;EACI,aAAA;AAPJ;;AAUA;EACI,aAAA;EACA,iBAAA;AAPJ;;AAUA;EACI,iCAAA;EACA,kBAAA;EACA,2BAAA;EACA,0BAAA;EACA,yBAAA;EAEA,gBAAA;EACA,2BAAA;AARJ;;AAWA;EACI,2BAAA;EACA,uBAAA;EACA,4BAAA;AARJ;;AAWA;EACI,yBAAA;AARJ;;AAWA;EACI,2BAAA;EACA,uBAAA;EACA,2BAAA;AARJ;;AAWA;EACI,yBAAA;AARJ;;AAWA;EACI,2BAAA;EACA,uBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,yBAAA;AATJ;;AAYA;EACI,uBAAA;AATJ;;AAYA;EACI,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;AATJ;;AAYA;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AATJ;;AAYA;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AATJ;;AAYA;EACI,yBAAA;AATJ;;AAYA;EACI,YAAA;EACA,YAAA;AATJ;;AAYA;EACI,kBAAA;EACA,cAAA;AATJ;;AAYA;EACI,6BAAA;EACA,4BAAA;EACA,WAAA;EACA,UAAA;AATJ;;AAYA;EACI,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,wBAAA;EACA,aAAA;EACA,YAAA;AATJ;;AAYA;EACI,eAAA;EACA,4BAAA;EACA,2BAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AATJ;AAWI;EACI,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,4CAAA;EACA,kBAAA;EACA,yBAAA;EACA,wBAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;AATR;AAYI;EACI,aAAA;AAVR;AAaI;EACI,iBAAA;EACA,eAAA;AAXR;AAcI;EACI,kBAAA;EACA,eAAA;AAZR;AAeI;EACI,gBAAA;EACA,aAAA;AAbR;AAeQ;EACI,qBAAA;EACA,kBAAA;AAbZ;AAgBQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAdZ;AAkBI;EACI,gBAAA;AAhBR;AAkBQ;EACI,aAAA;AAhBZ;AAkBY;EACI,iBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAhBhB;AAmBY;EACI,iBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAjBhB","sourcesContent":[".calendar {\n    background: #f3f4f6 !important;\n    overflow: hidden !important;\n    height: 170vh;\n\n    &__head {\n        display: flex;\n        align-items: center;\n        padding: 60px 42px 0px 42px;\n\n        &__text {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 28px;\n            line-height: 38px;\n            color: #333333;\n        }\n\n        &__button {\n            margin-left: auto;\n        }\n    }\n\n    &__events {\n        display: flex;\n\n        &__icon {\n            margin-right: 10px;\n            margin-left: 5px;\n        }\n    }\n\n    &__main {\n        padding: 20px 42px 50px 42px;\n    }\n}\n\n.fc-view-harness {\n    height: 133vh !important;\n}\n\n.fc-daygrid {\n    border-radius: 16px;\n}\n\n.fc-daygrid-day-top {\n    float: left;\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #868686;\n}\n\n.fc-scrollgrid-sync-inner {\n    float: left;\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: #505054;\n\n    margin-top: 5px;\n}\n\n.fc-scrollgrid-sync-table {\n    background: white;\n}\n\n.fc-day-today {\n    background: #fffcf2 !important;\n}\n\n.fc-theme-standard td,\n.fc-theme-standard th {\n    border: 1px solid #f2f2f2;\n}\n\n.fc-scroller-harness {\n    border-bottom: 1px solid #e9e9e9;\n}\n\n.fc-scroller {\n    overflow: hidden !important;\n}\n\n.fc-col-header-cell {\n    background: white !important;\n    height: 50px;\n    // border-radius: 16px;\n}\n\n.fc-daygrid-day-events {\n    padding-top: 30px;\n}\n\n.fc-daygrid-day {\n    height: 170px;\n}\n\n.fc-toolbar-chunk {\n    display: flex;\n    padding-left: 0px;\n}\n\n.fc-toolbar-title {\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    font-weight: 500 !important;\n    font-size: 18px !important;\n    color: #505054 !important;\n\n    padding-top: 8px;\n    margin-left: 0px !important;\n}\n\n.fc-prev-button {\n    background: none !important;\n    border: none !important;\n    padding-left: 0px !important;\n}\n\n.fc-icon-chevron-left {\n    color: #505054 !important;\n}\n\n.fc-next-button {\n    background: none !important;\n    border: none !important;\n    margin-left: 0px !important;\n}\n\n.fc-icon-chevron-right {\n    color: #505054 !important;\n}\n\n.fc-h-event {\n    background: none !important;\n    border: none !important;\n\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    font-weight: 400;\n    display: flex;\n    color: #333333 !important;\n}\n\n.fc-scrollgrid {\n    border: none !important;\n}\n\n.fc .fc-scrollgrid-liquid {\n    background: white;\n    padding: 10px;\n    border-radius: 16px;\n    height: none;\n    height: 125vh;\n}\n\n.fc-daygrid-day-number {\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #868686;\n}\n\n.fc-col-header-cell-cushion {\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: #505054;\n}\n\n.fc-event-main {\n    color: #333333 !important;\n}\n\n.x {\n    z-index: 100;\n    color: black;\n}\n\n.position-relative {\n    position: relative;\n    padding: 100px;\n}\n\n.swal2-popup {\n    position: relative !important;\n    left: var(--x) px !important;\n    left: 300px;\n    top: 200px;\n}\n\n.someClass {\n    background: var(--bg);\n    position: relative;\n    left: var(--x) !important;\n    top: var(--y) !important;\n    height: 150px;\n    width: 400px;\n}\n\n.calendar-modal {\n    position: fixed;\n    left: var(--xDir) !important;\n    top: var(--yDir) !important;\n    right: 0;\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 100;\n\n    &__popup {\n        position: block;\n        background: #ffffff;\n        border: 1px solid #e9e9e9;\n        box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);\n        border-radius: 8px;\n        left: var(--x) !important;\n        top: var(--y) !important;\n        height: 165px;\n        width: 472px;\n        padding: 30px;\n    }\n\n    &__action {\n        display: flex;\n    }\n\n    &__close {\n        margin-left: auto;\n        cursor: pointer;\n    }\n\n    &__icons {\n        margin-right: 20px;\n        cursor: pointer;\n    }\n\n    &__task-name {\n        margin-top: 20px;\n        display: flex;\n\n        &__icon {\n            align-content: center;\n            margin-right: 10px;\n        }\n\n        &__text {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 20px;\n            line-height: 30px;\n            color: #333333;\n        }\n    }\n\n    &__dates {\n        margin-top: 10px;\n\n        &__task-date-range {\n            display: flex;\n\n            &__text {\n                margin-right: 5px;\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 400;\n                font-size: 14px;\n                line-height: 20px;\n                color: #868686;\n            }\n\n            &__dates {\n                margin-right: 5px;\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 400;\n                font-size: 14px;\n                line-height: 20px;\n                color: #333333;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
